import * as types from '../../constants/types';

export function forceLogout(status: boolean) {
  return {
    type: types.SET_FORCE_LOGOUT,
    payload: status,
  }
}
